import React from "react";
import { Layout, Button, Card } from "antd";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "../component/header";

const { Content } = Layout;

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout className="min-h-screen bg-white">
      <HeaderComponent />
      <Content className="flex items-center justify-center p-8">
        <Card className="max-w-2xl w-full shadow-lg rounded-lg">
          <div className="flex flex-col items-center text-center gap-8 p-8">
            <div className="w-full">
              <h1 className="text-3xl md:text-4xl font-semibold text-[#263345] mb-4">
                Welcome to ChiroFutures
              </h1>
              <p className="text-base text-gray-600 mb-6">
                Get fast, reliable quotes and manage your policies with ease.
                Start by logging in, registering, or requesting a new quote.
              </p>
              <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
                <Button
                  type="primary"
                  size="large"
                  onClick={() => navigate('/login')}
                  style={{ minWidth: 160 }}
                  className="w-full sm:w-auto"
                >
                  Login
                </Button>

                <Button
                  type="primary"
                  size="large"
                  onClick={() => navigate('/verification')}
                  style={{ minWidth: 160 }}
                  className="w-full sm:w-auto"
                >
                  Register
                </Button>

                <Button
                  type="primary"
                  size="large"
                  onClick={() => navigate('/online-quotation-inquiry')}
                  style={{ minWidth: 160 }}
                  className="w-full sm:w-auto border border-gray-300"
                >
                  Get a Quote
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </Content>
    </Layout>
  );
};

export default HomePage;
